import { TripType } from "@b2bportal/air-shopping-api";
import { TripCategory } from "@overrides/types";

export const tripCategoryToTripType = (tripCategory: TripCategory) => {
  switch (tripCategory) {
    case TripCategory.ONE_WAY:
      return TripType.one_way;
    case TripCategory.ROUND_TRIP:
      return TripType.round_trip;
    case TripCategory.MULTI_CITY:
      return TripType.open_jaw;
  }
};
